import Login from '../../../pages/login';
import ForgotPassword from '../../../pages/forgot-password';
import UpdatePassword from '../../../pages/update-password';
import ChangePassword from '../../../pages/change-password';
import Resume from '../../../pages/resume';
import Orders from '../../../pages/orders';
import OrderDetail from '../../../pages/order';
import OrderList from '../../../pages/order-list';
import OrderLabels from '../../../pages/order-labels';
import OrderPdf from '../../../pages/order-pdf';
import InvoicingOrders from '../../../pages/invoicing-orders';
import DispatchPdf from '../../../pages/dispatch-pdf';
import DashboardJa from '../../../pages/dashboard-ja';
import AuditMonitor from '../../../pages/audit-monitor';
import Customers from '../../../pages/customers';
import confirmSignup from '../../../pages/confirm-signup';
import Users from '../../../pages/users';
import Profiles from '../../../pages/profiles';
import Permissions from '../../../pages/permissions';
import PickersMonitor from '../../../pages/pickers-monitor';
import OrdersMonitor from '../../../pages/orders-monitor';
import RoomManagement from '../../../pages/room-management';
import PositionsDarkstore from '../../../pages/positions-darkstore';
import Categories from '../../../pages/categories';
// import Scheduling from '../../../pages/scheduling';
// import VtexResume from '../../../pages/vtex-resume';
// import Settings from '../../../pages/settings';
// import Tracking from '../../../pages/tracking';
// import SandboxPage from '../../../pages/sandbox-page';
// import StockSearch from '../../../pages/stock-search';
import Home from '../../../pages/home';
import Redirect from '../adfs/Redirect';
import PositionsQr from '../../../pages/positions-qr';
import Shoppers from '../../../pages/shoppers';
import OperUsers from '../../../pages/oper-users';
import UserSalesChannels from '../../../pages/user-salesChannels';
import ShoppersForm from '../../../pages/shoppers-form';
import ShopperNotifications from '../../../pages/shopper-notifications';
import SCSettings from '../../../pages/sc-settings';
import SCGlobalSettings from '../../../pages/sc-global-settings';
import InvoicingMonitor from '../../../pages/invoicing-monitor';
import AddresseesNotifications from '../../../pages/addressees-notifications';
import AddresseesNotificationsReports from '../../../pages/addressees-notifications-reports';
import PositionsMaintainerDarkstore from '../../../pages/positions-maintainer-darkstore';
import Search from '../sections/Search';
import Marketplace from '../sections/Marketplace';
import Polls from '../../../pages/polls';
import ShopperTraining from '../../../pages/shopper-training';
import Blacklist from '../../../pages/blacklist';
import Substitutions from '../../../pages/substitutions';
import ExternalFactors from '../../../pages/external-factors';
import ShopperAppLogs from '../../../pages/shopper-app-logs';
import SplitOrder from '@cencosud-cencommerce/frontend-module-split-order/src/App.tsx';

const routes = [
    {
        path: '/split-order',
        component: SplitOrder
    },
    {
        path: '/orders-monitor',
        component: OrdersMonitor
    },
    {
        path: '/room-management',
        component: RoomManagement
    },
    {
        path: '/resume',
        component: Resume
    },
    {
        path: '/orders',
        component: Orders
    },
    {
        path: '/orders/:id',
        component: OrderDetail
    },
    {
        path: '/dashboard-ja',
        component: DashboardJa
    },
    {
        path: '/audit-monitor',
        component: AuditMonitor
    },
    {
        path: '/invoicing-monitor',
        component: InvoicingMonitor
    },
    /* {
        path: '/scheduling',
        component: Scheduling
    }, */
    /* {
        path: '/vtex-resume',
        component: VtexResume
    }, */
    /* {
        path: '/settings',
        component: Settings
    }, */
    /* {
        path: '/tracking',
        component: Tracking
    }, */
    /* {
        path: '/sandbox-page',
        component: SandboxPage
    }, */
    /* {
        path: '/stock-search',
        component: StockSearch
    }, */
    {
        path: '/customers',
        component: Customers
    },
    {
        path: '/shoppers',
        component: Shoppers
    },
    {
        path: '/users',
        component: Users
    },
    {
        path: '/oper-users',
        component: OperUsers
    },
    {
        path: '/user-salesChannels',
        component: UserSalesChannels
    },
    {
        path: '/profiles',
        component: Profiles
    },
    {
        path: '/permissions',
        component: Permissions
    },
    {
        path: '/pickers-monitor',
        component: PickersMonitor
    },
    {
        path: '/categories',
        component: Categories
    },
    {
        path: '/positions',
        component: PositionsDarkstore
    },
    {
        path: '/positions-maintainer-darkstore',
        component: PositionsMaintainerDarkstore
    },
    {
        path: '/shoppers-form',
        component: ShoppersForm
    },
    {
        path: '/shopper-notifications',
        component: ShopperNotifications
    },
    {
        path: '/sc-settings',
        component: SCSettings
    },
    {
        path: '/sc-global-settings',
        component: SCGlobalSettings
    },
    {
        path: '/addressees-notifications',
        component: AddresseesNotifications
    },
    {
        path: '/addressees-notifications-reports',
        component: AddresseesNotificationsReports
    },
    {
        path: '/polls',
        component: Polls
    },
    {
        path: '/shopper-training',
        component: ShopperTraining
    },
    {
        path: '/blacklist',
        component: Blacklist
    },
    {
        path: '/substitutions',
        component: Substitutions
    },
    {
        path: '/external-factors',
        component: ExternalFactors
    },
    {
        path: '/shopper-app-logs',
        component: ShopperAppLogs
    }
];

const routesWithoutSidebar = [
    {
        path: '/',
        component: Home
    },
    {
        path: '/login',
        component: Login
    },
    {
        path: '/redirect',
        component: Redirect
    },
    {
        path: '/forgot-password',
        component: ForgotPassword
    },
    {
        path: '/update-password',
        component: UpdatePassword
    },
    {
        path: '/change-password',
        component: ChangePassword
    },
    {
        path: '/confirm-signup',
        component: confirmSignup
    },
    {
        path: '/order-labels/:id',
        component: OrderLabels
    },
    {
        path: '/order-list/:id',
        component: OrderList
    },
    {
        path: '/order-pdf/:id',
        component: OrderPdf
    },
    {
        path: '/dispatch-pdf/:id',
        component: DispatchPdf
    },
    {
        path: '/positions-qr/:id',
        component: PositionsQr
    },
    {
        path: '/invoicing-orders/:data',
        component: InvoicingOrders
    },
    {
        path: '/search',
        component: Search
    },
    {
        path: '/marketplace/:storeId?/*',
        component: Marketplace
    }
];

export {
    routes,
    routesWithoutSidebar
};
